<template>
	<i
		:style="iconStyle"
		:class="iconClasses"
		v-html="material"
		@click="$emit('click', $event)"
	/>
</template>

<style lang="scss" src="./_v-icon.scss"/>

<script lang="ts">
const ICON_THEMES = ['outlined', 'two-tone', 'round', 'sharp'];

export default defineComponent({
	name: 'VIcon',
	inheritAttrs: true,

	emits: ['click'],

	props: {
		material: {
			type:    String,
			default: null,
		},
		theme: {
			type:      String,
			default:   null,
			validator: (v) => ICON_THEMES.includes(v),
		},
		image: {
			type:    String,
			default: null,
		},
	},

	computed: {
		iconClasses() {
			const classes = { 'mds-icon': true };

			if (typeof this.material === 'string') {
				let materialClass = 'material-icons';
				if (this.theme !== null) {
					materialClass += `-${this.theme}`;
				}
				classes[materialClass] = true;
			} else if (typeof this.image === 'string') {
				classes['image'] = true;
			}

			return classes;
		},

		iconStyle() {
			if (typeof this.image === 'string') {
				return {
					backgroundImage: `url(${this.image})`,
				};
			}
			return {};
		},
	},
});
</script>
